export default "__VITE_ASSET__iFAuEgJh__"